import Vue from 'vue'
import Vuex from 'vuex'

import academy from './modules/academy'
import assets from './modules/assets'
import auth from './modules/auth'
import maps from './modules/maps'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    academy,
    assets,
    auth,
    maps
  }
})
